// @flow

import _ from 'lodash';
import React, { useState, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { Icon, Badge, Popover, ActionList } from '@shopify/polaris';
import { Link } from 'react-router-dom';
import { DropdownMinor } from '@shopify/polaris-icons';

import { getShop } from 'src/helpers';
import history from 'src/routes/history';

type Props = {
  menuId: string,
  data: Object,
  host: string
};

type ComposedProps = Props & WithI18nProps;

const MainMenuItem: React.FC<ComposedProps> = ({ menuId, menuIdMetaMatchOldNav, data, host }) => {
  const [popoverActive, setPopoverAction] = useState(false);
  const { id, title, routeTo, subMenu, badge } = data;
  const shop = getShop();

  const hasSubMenu = _.isEmpty(routeTo);
  let content = null;

  const togglePopoverActive = useCallback(() => {
    setPopoverAction(prevState => !prevState);
  }, []);

  const location = useLocation();

  if (hasSubMenu) {
    const activator = (
      <span className={!_.isEmpty(subMenu) ? 'dropbtn' : ''}>
        {title}
        {!_.isEmpty(subMenu) ? <Icon source={DropdownMinor} /> : ''}
        {badge && badge.content && <Badge status={badge.info || 'info'}>{badge.content}</Badge>}
      </span>
    );
    const actionList = (
      <ActionList
        items={subMenu
          .filter(sub => !sub.isHide)
          .map(({ title, id, routeTo, badge: subBadge }) => ({
            content: title,
            badge: subBadge,
            id,
            active: id === menuId,
            onAction: () => {
              if (location.pathname !== routeTo) {
                history.push(routeTo);
              }
            }
          }))}
      />
    );

    content = (
      <Popover active={popoverActive} activator={activator} onClose={() => {}}>
        {actionList}
      </Popover>
    );
  } else {
    content = (
      <Link id={id} to={`${routeTo}?shop=${shop}&host=${host}`}>
        <div>
          {title}
          {badge && badge.content && <Badge status={badge.info || 'info'}>{badge.content}</Badge>}
        </div>
      </Link>
    );
  }

  const events = hasSubMenu
    ? {
        onMouseEnter: togglePopoverActive,
        onMouseLeave: togglePopoverActive
      }
    : {};
  return (
    <li
      {...events}
      className={`menuItem ${id} ${!_.isEmpty(subMenu) ? 'dropdown' : ''} ${
        menuId.indexOf(id) > -1 || menuIdMetaMatchOldNav?.indexOf(id) > -1 ? 'active' : ''
      } ${popoverActive ? 'hovered' : ''}`}>
      {content}
    </li>
  );
};

const mapStateToProps = state => {
  return {
    host: _.get(state.oauth, 'host', '')
  };
};

export default connect(mapStateToProps)(withI18n()(MainMenuItem));
